<template>
  <Content id="childrenAbcScale">
    <div slot="search">
      <Form :label-width="70" :model="search">
        <Row>
          <Col>
            <FormItem  label="幼儿园"  prop="kindergartenId" :label-width="60">
              <el-select v-model.trim="search.kindergartenId" placeholder="幼儿园"
                         clearable filterable
                         size="small"
                         transfer="true"
                         :popper-append-to-body="false"
                         style="width: 300px;">
                <el-option v-for="item in kindergartenList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"
                           @click.native="handleKindergartenChange(item)"
                           style="width:300px;z-index: 9999;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="姓名">
              <Input v-model="search.name" style="width:120px;"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="性别">
              <Select v-model="search.gender" style="width:100px;">
                <Option v-for="item in genderList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width:100px;">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.source" style="width:100px;">
                <Option v-for="item in sourceList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="测评时间" :label-width="110">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart"></DatePicker>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend"></DatePicker>
            </FormItem>
          </Col>
        <!--
        <Col>
            <FormItem label="发布状态">
              <Select v-model="search.publishStatus" style="width:100px;">
                <Option v-for="item in publishStatusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="开放状态">
              <Select v-model="search.openStatus" style="width:100px;">
                <Option v-for="item in openStatusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          -->
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="handleDataList">搜索</Button>
            </div>
          </Col>
        </Row>
      </Form>
      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button type="primary" size="small" icon="md-add" @click="handleCreate">添加</Button>
          <Button type="primary" size="small" style="margin-left: 5px;" icon="ios-download-outline" @click="downloadex()">报告</Button>
<!--          <Button type="primary" size="small" style="margin-left: 5px;" icon="ios-download-outline" @click="exportData">导出</Button>-->
        </div>
      </div>
    </div>

    <Table ref="list"  :columns="columns" :loading="list.loading" :data="list.data"
           highlight-row :row-class-name="tableRowClassName" @on-selection-change="selectList">
      <template slot-scope="{row}" slot="operation">
        <a @click.stop="report(row)">报告</a>&nbsp;|&nbsp;
        <a @click.stop="print(row)">打印</a>&nbsp;|&nbsp;

        <a @click.stop="edit(row)">编辑</a>&nbsp;|&nbsp;
<!--        <a @click.stop="visit(row)">回访</a>&nbsp;|&nbsp;-->
        <a @click.stop="del(row)">删除</a>
      </template>
    </Table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer size="small" @on-change="chagecurrent"
          :page-size-opts="[10, 20, 40, 80]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="55%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <mChatREdit ref="edit" :style="{'overflow-y':'auto','max-height':'600px'}" :class="getClass" @on-submit="handleSubmit" />
      <div slot="footer" style="text-align: center;">
        <Button type="primary" @click="submit">确定</Button>
        <Button type="info" @click="reset">重置</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

    <Modal v-model="visitWindow" width="55%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <visitMChat ref="visit" :style="{'overflow-y':'auto','max-height':'600px'}" :class="getClass" @on-submit="handleVisitSubmit" />
      <div slot="footer" style="text-align: center;">
        <Button type="primary" @click="visitSubmit">确定</Button>
        <Button type="info" @click="visitReset">重置</Button>
        <Button @click="visitWindow = false">取消</Button>
      </div>
    </Modal>

    <span v-show="printData&&showPrint">
     <a id="print" v-print="printContent" v-show="false">打印</a>
     <printMChat ref="printPage" :formData="printData" :show.sync="showPrint"/>
    </span>

  </Content>
</template>
<script>
import {_selectPages, _download, _export, _delete, _print} from "@/services/autism/mChat";
import {_kindergartens} from "@/services/manage/kindergartens";
import mChatREdit from "./mChatEdit.vue"
import visitMChat from "./visitMChat.vue"
import printMChat from "@/views/autism/mChat/printMChat/printMChat.vue"
import dayjs from "dayjs";
export default {
  inject: ['reload'],
  name: "MChatR",
  components: {
    mChatREdit,
    visitMChat,
    printMChat
  },
  computed: {
    getClass() {
      const width = window.innerWidth;
      if (width < 600) {
        return 'small-screen';
      } else if (width < 1200) {
        return 'medium-screen';
      } else {
        return 'large-screen';
      }
    }
  },
  data() {
    return {
      editWindow: false,
      visitWindow: false,
      windowTitle: "新增",
      showPrint: false,
      search: {
        kindergartenId: "",
        name: "",
        endDate:dayjs().format('YYYY-MM-DD'),
        startDate:dayjs().format('YYYY-MM-DD'),
        gender: "",
        source: "",
        publishStatus: "",
        openStatus: "",
        ids:"",
      },
      idList:[],
      printData:{},
      kindergartenList:[],
      list: {
        data: [],
        loading: false
      },
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      genderList: [
        {label: '全部', value: ""},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      statusList: [
        {label: '全部', value: ""},
        {label: '未测评', value: 1},
        {label: '已测评', value: 2},
      ],
      sourceList: [
        {label: '全部', value: ""},
        {label: '二维码', value: 1},
        {label: '自主填写', value: 2},
      ],
      publishStatusList: [
        {label: '全部', value: ""},
        {label: '未发布', value: 1},
        {label: '已发布', value: 2},
      ],
      openStatusList: [
        {label: '全部', value: ""},
        {label: '未开放', value: 1},
        {label: '已开放', value: 2},
      ],
      columns: [
        {
          title: "姓名",
          key: "name",
          minWidth: 80,
          fixed: "left",
          align: 'center',
        },
        {
          title: "性别",
          key: "gender",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.gender === 1 ? "男" : "女")
        },
        {
          title: "年龄",
          key: "age",
          minWidth: 60
        },
        {
          title: "出生日期",
          key: "birthday",
          minWidth: 200,
        },
        {
          title: "关系",
          key: "relation",
          minWidth: 80,
        },
        {
          title: "二维码编号",
          key: "qrcodeId",
          minWidth: 150,
          fixed: "left",
          align: 'center',
        },
        {
          title: "得分",
          key: "totalScore",
          minWidth: 80,
        },
        {
          title: "结果",
          key: "scoreRemark",
          minWidth: 200,
        },
        {
          title: "操作",
          slot: "operation",
          align: "center",
          fixed: "right",
          minWidth: 210
        }
      ],
      printContent:{
        id:"printPage",
        preview:false,
        previewTitle:'  ',
        popTitle:'  ',
        extraHead:'<meta http-equiv="Content-Language"content="zh-cn"/>',
        previewBeforeOpenCallback(){
          // console.log('正在加载预览窗口')
        },
        previewOpenCallback(){
          // console.log('已经加载完预览窗口')
        },
        beforeOpenCallback(vue){
          vue.printLoading=true
          // console.log('打开之前')
        },
        openCallback(vue){
          vue.printLoading=false
          // console.log('执行了打印')
        },
        closeCallback(){
          // console.log('关闭了打印工具')
        },
        clickMounted(vue){
          //console.log('点击了打印按钮');
          vue.printContent.popTitle="      "
        }
      },
    };
  },
  mounted() {
    this.columns.unshift({
      type: 'selection',
      width: 40,
      align: 'center',
      fixed: "left",
    })

    if (!this.$userSession.checkInstitutionId()){
      return;
    }
    this.kindergartens();
    this.handleDataList();
  },
  methods: {
    handleKindergartenChange(item) {
      this.search.kindergartenId = item.id;
    },
    tableRowClassName(row, rowIndex) {
      row.index = rowIndex;
      if (this.currentRowIndex === rowIndex) {
        return "success-row";
      }
    },
    selectList(e){
      this.idList = []
      e.forEach(item=>{
        this.idList.push(item.id)
      })
    },
    kindergartens(){
      _kindergartens().then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.kindergartenList = res.data;
        }
      }).catch(() => {});
    },
    handleDataList() {
      if (!this.$userSession.checkInstitutionId()){
        this.$message.warning('请先选择机构');
        return;
      }
      delete this.search.ids;

      _selectPages({
        ...this.search,
        currentPage: this.pageList.currentPage,
        pageSize: this.pageList.pageSize
      }).then(res => {
        this.$Loading.finish();
        const {records, total} = res.data;
        this.list = {
          data: records,
          loading: false
        };
        this.pageList.total = total;
      }).catch(() => {
        this.$Loading.error();
        this.list.loading = false;
      });
    },
    submit() {
      this.$refs['edit'].handleSubmit();
    },
    reset(){
      this.$refs['edit'].reset();
    },
    handleSubmit() {
      this.editWindow = false;
      this.pageList.currentPage = 1;
      setTimeout(()=>{
        this.handleDataList();
      },100);
    },
    exportData() {
      if (!this.$userSession.checkInstitutionId()){
        this.$message.warning('请先选择机构');
        return;
      }
      this.search.ids = this.ids;
      _export(this.search).then(res => {

      }).catch(error => {
        console.log("error", error)
      });
    },
    downloadex(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      if(!this.pageList.total || this.pageList.total === 0){
        this.$message.warning('列表没有数据，不能操作下载');
        return;
      }
      if(this.idList && this.idList.length > 0){
        this.search.ids = this.idList.toString();
      }

      _download(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.$message.success('提交下载报告成功, 请稍后到【导出记录管理】下载结果');
        } else{
          this.$message.error(res.errmsg)
        }
      })
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()){
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal(true, this.windowTitle, null);
    },
    edit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(false, this.windowTitle, row);
    },
    visit(row){
      this.windowTitle = "回访";
      this.visitWindow = true;
      this.$refs["visit"].handleModal(row);
    },
    visitSubmit() {
      this.$refs['visit'].handleSubmit();
    },
    visitReset(){
      this.$refs['visit'].reset();
    },
    handleVisitSubmit() {
      this.visitWindow = false;
      this.pageList.currentPage = 1;
      setTimeout(()=>{
        this.handleDataList();
      },100);
    },
    report(e){
      const routerData = this.$router.resolve({
        path: '/autism/MChat/printMChat',
        query: {institutionId:e.institutionId, id: e.id}
      })
      window.open(routerData.href, "_blank")
    },
    print(row) {
      _print({institutionId: row.institutionId, id: row.id}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.printData = res.data
        this.printData.institutionName = this.printData.institutionName + (this.printData.subordinate&&this.printData.subordinate.length > 0 ? "-" + this.printData.subordinate : "")

        this.$nextTick(()=>{
          document.getElementById('print').click();
        })
      })
    },
    del(row) {
      this.$confirm('是否确定删除 ' + row.name +'?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _delete({id:row.id}).then(res=>{
          if (res && res.errcode && res.errcode === 1){
            this.handleDataList();
            this.$message.success("删除成功")
          }else{
            this.$message.error(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
  }
};
</script>
<style lang="postcss" scoped>

</style>
